var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinCommentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 602,
    width: 802,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    id: "svg_1",
    fillRule: "evenodd",
    d: "m7.32,9.281l9.762,0l0,0.961l-9.762,0l0,-0.961zm0,3.883l6.84,0l0,-0.96l-6.84,0l0,0.96zm15.602,-1.851c0,1.222 -0.258,2.257 -0.887,3.328c-0.48,0.851 -1.07,1.48 -1.883,2.07l-7.949,5.25l0,-3.918l-3.922,0c-1.258,0 -2.328,-0.258 -3.402,-0.887a6.836,6.836 0 0 1 -2.512,-2.515c-0.629,-1.07 -0.887,-2.145 -0.887,-3.403c0,-1.254 0.258,-2.328 0.887,-3.437c0.63,-1.07 1.442,-1.848 2.512,-2.477a6.45,6.45 0 0 1 3.402,-0.926l7.84,0a6.45,6.45 0 0 1 3.402,0.926c1.07,0.63 1.883,1.406 2.512,2.477c0.63,1.11 0.887,2.183 0.887,3.437l0,0.075zm-2.586,-2.513c-0.445,-0.778 -1,-1.367 -1.773,-1.813c-0.778,-0.445 -1.555,-0.629 -2.442,-0.629l-7.84,0c-0.886,0 -1.664,0.184 -2.437,0.63c-0.778,0.445 -1.332,1.034 -1.778,1.812c-0.441,0.777 -0.664,1.515 -0.664,2.437c0,0.89 0.223,1.664 0.664,2.442c0.446,0.777 1,1.332 1.778,1.773c0.773,0.445 1.55,0.668 2.437,0.668l5.88,0l0,2.219l4.882,-3.219c0.555,-0.406 0.96,-0.848 1.328,-1.441c0.406,-0.778 0.629,-1.477 0.629,-2.367l0,-0.075c0,-0.922 -0.223,-1.66 -0.664,-2.437zm0,0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinCommentIcon);
export default __webpack_public_path__ + "static/media/linkedin-comment-icon.2fd09f7e3d57a37cb96d6113c2758130.svg";
export { ForwardRef as ReactComponent };